import { DrawerProps } from '@mui/material';

import * as S from './Drawer.styled';

interface IProps extends DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  isExtended?: boolean;
  width?: number;
  children: React.ReactNode;
}

export const Drawer = ({ isOpen, onClose, isExtended, width = 400, children, ...rest }: IProps) => (
  <S.Drawer
    width={isExtended ? width * 2 : width}
    open={isOpen}
    onClose={onClose}
    variant="temporary"
    anchor="right"
    {...rest}
  >
    <S.Wrapper>{children}</S.Wrapper>
  </S.Drawer>
);
